import React from "react";

import manOnStairs from "../assets/gfx/03_man-on-stairs.jpg";

export const BestPractice: React.FC<{}> = () => {
  return (
    <div className="row">
      <div className="col-md-6">
        <div className="">
          <img className="img-fluid" src={manOnStairs} alt="Man on stairs" />
        </div>
      </div>
      <div className="col-md-6 d-flex flex-column">
        <p>
          Moving from good practice through to best practice can take time and
          commitment. Strategies can be implemented and built upon over a period
          of time, gradually moving towards a program that is considered best
          practice. Here’s an example using healthy eating and drinking.
        </p>
        <p>Good practice strategies could include:</p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>Displaying healthy choices (posters etc.) at the workplace.</p>
          </li>
          <li>
            <p>
              Providing basic kitchen facilities such as eating utensils, a
              fridge, pantry and washing up facilities.
            </p>
          </li>
          <li>
            <p>
              When providing catering, giving preference to food outlets with
              healthy choices.
            </p>
          </li>
        </ul>
        <p>Better practice strategies could include:</p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>
              Organising a social soup or salad group where staff bring in
              healthy meals to share.
            </p>
          </li>
          <li>
            <p>
              Providing food preparation equipment such as sharp knives,
              chopping boards and a toaster.
            </p>
          </li>
          <li>
            <p>
              When providing catering, requesting healthier foods from providers
              and ensuring portion size is considered.
            </p>
          </li>
        </ul>
        <p>Best practice strategies could include:</p>
        <ul className="bullet-fulcrum bullet-gold mb-4">
          <li>
            <p>
              Providing healthy cooking classes and healthy eating education.
            </p>
          </li>
          <li>
            <p>
              Providing advanced kitchen facilities and equipment such as an
              oven, a stove, blender, grater etc.
            </p>
          </li>
          <li>
            <p>
              Having a catering policy in place ensuring a minimum of 50% of
              provided food and drink is healthy and no more than 20% of
              provided food and drink is unhealthy.
            </p>
          </li>
        </ul>
        <p>
          Download our{" "}
          <a
            href="https://cdn.livelighter.com.au/assets/resource/workplace/2021-07-best-practice-guide.pdf"
            download="Best practice guide: Workplace health and wellbeing strategies"
            title="Download best practice guide: Workplace health and wellbeing strategies"
            className="text-reset text-underline"
          >
            Best practice guide: Workplace health and wellbeing strategies
          </a>{" "}
          factsheet for a range of good, better and best strategies for each of
          these behavoural risk factors.
        </p>
      </div>
    </div>
  );
};
